/**************************************************
 * Nombre:       Pqrsf_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Checkbox, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import fondo from '../../../Recursos/fondo_agendar.png'
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Pqrs from "../../Formularios/Formulario_Pqrs";
import {useState} from "react";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../../Recursos/logo_redondo.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {obtenerConsecutivo} from "../../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../../Servicios/BD/Consecutivos/aumentarConsecutivo";


const Pqrsf_Portada = () => {
    const {sCell, masSM} = useResponsive()
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: setEntidad})
    const [acepto, setAcepto] = useState(true)

    const enviar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Enviando Datos')
        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'pqrss'})
        entidad.consecutivo = conse.data
        entidad.estado = 'Nuevo'
        let dox = await guardarDoc('pqrss', entidad)
        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'pqrss', actual: entidad.consecutivo})
            terminar({aviso: 'Datos enviados con exito, pronto nos contactaremos contigo'})
        } else {
            terminar({aviso: 'Algo indesperado paso, porfavor intentalo nuevamente', variante: 'error'})
        }


    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Cargador/>

                <Avisos/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                color: theme.palette.primary.main,
                                fontSize: sCell ? 32 : 40,
                                lineHeight: 1.2
                            }}>FORMULARIO
                                PQRSF</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                color: theme.palette.primary.main,
                                fontSize: 18,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                Completa los campos y enviaremos tu solicitud de forma segura.
                            </Typography>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 8, md: 6}}
                            sx={{
                                backgroundImage: `url(${fondo})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                p: 4,
                                mt: 6
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Formulario_Pqrs props={props}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                <Typography sx={{fontSize: sCell ? 14 : 16, lineHeight: sCell ? 1 : 1.6}}>
                                    <Checkbox checked={acepto} onChange={() => setAcepto(!acepto)}
                                              sx={{mt: -0.2}}
                                    /> Acepto <span style={{textDecoration: 'underline', cursor: 'pointer'}}>
                                    politicas de
                                    tratamientos de datos
                                        </span>
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                                <Button
                                    disabled={!acepto}
                                    onClick={() => enviar()}
                                >Enviar</Button>
                            </Grid>


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Pqrsf_Portada  